export default "__VITE_ASSET__3c25ce88__"